import React from 'react';
import styles from './TowerUtility.module.scss';
import { useTranslation } from 'react-i18next';
import { HomeSectionTitle } from '../HomeSectionTitle/HomeSectionTitle';

import IconNft from '../../assets/imgs/home/icon-nfts.png';
import IconEventEntry from '../../assets/imgs/home/icon-event-entry.png';
import IconGovernance from '../../assets/imgs/home/icon-governance.png';


const TowerUtility = () => {
    const [t] = useTranslation();

    return (
        <div className={styles.tower_utility} id="utility">
            <div className={styles.section_title}>
                <HomeSectionTitle
                    title={t('TOWER_UTILITY')}
                />
            </div>

            <div className={styles.section_body}>
                <div className={`${styles.utility_card}`}>
                    <img src={IconNft} alt="icon-nft" />
                    <div className={styles.card_title}>{t('NFTs')}</div>
                    <div className={styles.description}>{t('TOWER_PURCHASE_NFTS_CKF')}</div>
                </div>

                <div className={`${styles.utility_card}`}>
                    <img src={IconEventEntry} alt="icon-event-entry" />
                    <div className={styles.card_title}>{t('EVENT_ENTRY')}</div>
                    <div className={styles.description}>{t('TOWER_ACCESS_GAMEPLAY_MODES_UPCOMING_GAME')}</div>
                </div>

                <div className={`${styles.utility_card}`}>
                    <img src={IconGovernance} alt="icon-governance" />
                    <div className={styles.card_title}>{t('GOVERNANCE')}</div>
                    <div className={styles.description}>{t('TOWER_ABLE_TO_VOTE_FOR_CKF')}</div>
                </div>
            </div>
        </div>
    )
}

export {TowerUtility}
